import { render, staticRenderFns } from "./projektmanagement-6-1.vue?vue&type=template&id=7f0a072c&"
import script from "./projektmanagement-6-1.vue?vue&type=script&lang=js&"
export * from "./projektmanagement-6-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports